import { create } from "zustand";

interface AdminNudgeModalState {
  close: () => void;
  isOpen: boolean;
  open: () => void;
}

// Lets useReviewInvitation check whether the admin nudge is open, without a DOM scan.
export const useAdminNudgeModalStore = create<AdminNudgeModalState>(set => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
